require('./common');
require('./front/index');
require('./front/cookie-banner');

